// extracted by mini-css-extract-plugin
export var accent = "TextInput-module--accent--16aef";
export var clearButton = "TextInput-module--clearButton--0a78c";
export var container = "TextInput-module--container--8e87e";
export var input = "TextInput-module--input--e6eef";
export var unit = "TextInput-module--unit--3223d";
export var withUnit = "TextInput-module--withUnit--93654";